module.exports = __webpack_public_path__ + "static/media/whitecarmob.d99ee0b2.svg";